module.exports = __webpack_public_path__ + "static/youtrack-1ad6f614146c340edb795a36e5f85143.png";